import { ProviderConfigSectionQuerySchema, ProviderConfigSectionResponseSchema, ProviderSystemInfoResponseSchema, SetProviderConfigRequestSchema, SetProviderConfigSectionRequestSchema, } from '../../schemas/provider-config.schemas.js';
import { BaseResponseSchema } from '../../schemas/primitives.js';
/** REST contract for `insight-api/src/routes/provider-config.routes.ts`. */
export const providerConfigContract = {
    getSection: {
        method: 'GET',
        path: '/provider/config',
        query: ProviderConfigSectionQuerySchema,
        response: ProviderConfigSectionResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to load provider configuration',
    },
    setValue: {
        method: 'POST',
        path: '/provider/config',
        body: SetProviderConfigRequestSchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to update configuration',
    },
    setSection: {
        method: 'PUT',
        path: '/provider/config/section',
        body: SetProviderConfigSectionRequestSchema,
        response: BaseResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to update configuration section',
    },
    getSystemInfo: {
        method: 'GET',
        path: '/provider/config/system-info',
        response: ProviderSystemInfoResponseSchema,
        responseStyle: 'parse-response',
        errorMessage: 'Failed to fetch system information',
    },
};
//# sourceMappingURL=provider-config.contract.js.map